const projectsData = [
  {
    title: "GoCamp",
    image:
      "https://us.123rf.com/450wm/nataliia2910/nataliia29101809/nataliia2910180900062/110071175-vector-illustration-of-camping-in-night-time-with-beautiful-view-on-mountains-family-camping-evening.jpg?ver=6",
    description:
      "GoCamp is a website where users can create and review campgrounds",
    link: "https://gocamp.onrender.com/"
  },
  {
    title: "ShadeSavvy",
    image:
      "https://c4.wallpaperflare.com/wallpaper/525/561/186/abstract-design-fractal-wallpaper-preview.jpg",
    description:
      "Discover and convert colors effortlessly with ShadeSavvy, a powerful tool that provides RGB, HSL, and HEX color codes.",
    link: "https://rhinoxd.github.io/shadesavvy/"
  },
  {
    title: "Pinsta",
    image:
      "https://images-ext-2.discordapp.net/external/a9OVhj13DmqFSAdMf3U7r27q5yfN2OKsoNzICzwhhSk/https/w0.peakpx.com/wallpaper/281/780/HD-wallpaper-instagram-blue-logo-blue-neon-lights-creative-blue-abstract-background-instagram-logo-social-network-instagram.jpg",
    description: "Share your life, one post at a time. ",
    link: "https://pinsta.onrender.com/"
  },
  {
    title: "DevConnector",
    image:
      "https://socialengineindia.com/blog/wp-content/uploads/2021/10/What-are-the-Core-features-of-a-Successful-Online-Community-Platform.png",
    description: "Social network for developers",
    link: "https://devconnector-r3x6.onrender.com/"
  },
  {
    title: "ShoppingCart",
    image:
      "https://media.wired.com/photos/5c9040ee4950d24718d6da99/191:100/w_2400,h_1256,c_limit/shoppingcart-1066110386.jpg",
    description: "Whatever you've got in mind, we've got inside.",
    link: "https://shopping-cart-w7bs.onrender.com/"
  },
  {
    title: "Rexx-Clothing",
    image:
      "https://cdn.pixabay.com/photo/2015/08/25/11/50/shop-906722_960_720.jpg",
    description: "A store that sells not just outfits but a trend.",
    link: "https://rexx-clothing.onrender.com/"
  }
];

export default projectsData;
